<template>
  <v-card
    dark
    class="primary darken-1"
    height="327"
    :min-width="minWidth"
    :width="width"
    style="border-radius: 5px; overflow-y: auto"
  >
    <v-expand-transition>
      <div
        v-if="bovines"
        class="d-flex transition-fast-in-fast-out primary darken-1 v-card--reveal"
      >
        <v-card-text class="secondary--text text--lighten-1 text-justify">
          <v-row>
            <v-col cols="6">
              <v-icon large color="secondary lighten-1" @click="toggleBovines"
                >mdi-arrow-left-circle</v-icon
              >
            </v-col>
            <v-spacer />
            <v-col cols="6" align-self="end" align="end">
              <v-icon large color="secondary lighten-1"> $bovines</v-icon>
            </v-col>
          </v-row>
          <br />
          {{ bovinesText }}
        </v-card-text>
      </div>
    </v-expand-transition>
    <div v-if="!bovines">
      <v-card-subtitle class="white--text text--white">
        <span class="textDate"
          ><v-icon small>restore</v-icon> atualizado em</span
        ><br />
        <span class="textDate">{{ bovinesTotal.updateDate }}</span>
      </v-card-subtitle>
      <v-card-title>
        <v-icon class="ml-n1" color="secondary lighten-1" large>
          $bovines
        </v-icon>
      </v-card-title>
      <v-card-subtitle class="white--text text--white">
        <strong class="textTitle">Bovinos</strong>
        <v-tooltip right color="#1A232F">
          <template v-slot:activator="{on, attrs}">
            <v-icon
              class="ml-1"
              color="secondary lighten-1"
              v-bind="attrs"
              v-on="on"
              @click="toggleBovines"
            >
              help_outline
            </v-icon>
          </template>
          <span>Clique para informações</span>
        </v-tooltip>
      </v-card-subtitle>
      <v-card-text class="white--text text--white">
        <v-row no-gutters v-if="bovinesTotalSia != null">
          <v-col cols="12">
            <div class="d-flex textBovines">Cabeças</div>
          </v-col>

          <v-col cols="12">
            <span class="textTotalBovines">{{
              Math.round(bovinesTotal.totalBovinesSia).toLocaleString('pt-BR', {
                maximumFractionDigits: 1,
              })
            }}</span
            ><span class="textBovines pt-4">
              /{{
                bovinesTotal.totalBovines.toLocaleString('pt-BR', {
                  maximumFractionDigits: 1,
                })
              }}</span
            >
          </v-col>
          <v-col cols="12" class="pt-2">
            <span class="textBovines"
              >{{
                (
                  (bovinesTotal.totalBovinesSia * 100) /
                  bovinesTotal.totalBovines
                ).toFixed(2)
              }}% do rebanho do estado</span
            >
            <br />
            <span class="textBovines pt-4"
              >{{
                Math.round(bovinesTotal.manancial).toLocaleString('pt-BR', {
                  maximumFractionDigits: 1,
                })
              }}
              bovinos/km² do manancial</span
            >
          </v-col>
        </v-row>

        <v-row no-gutters v-else>
          <v-col cols="12">
            <div class="d-flex textBovines">Cabeças</div>
          </v-col>

          <v-col cols="12">
            <span class="textTotalBovines">{{
              bovinesTotal.totalBovines.toLocaleString('pt-BR', {
                maximumFractionDigits: 1,
              })
            }}</span>
          </v-col>
        </v-row>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
  name: 'CardBovines',
  props: {
    minWidth: {
      required: true,
    },
    width: {
      required: true,
    },
  },

  data() {
    return {
      bovines: false,
      bovinesText:
        'Informações sobre bovinos se referem a espacialização do número de cabeças de gado do estado do Paraná (ADAPAR, 2019). Originalmente os dados que são compilados por município, foram desagregados de acordo com a unidade de análise de bacias hidrográficas. Foi realizada a ponderação da quantidade de cabeças de gado em cada manancial em função da porcentagem de área de pastagem de cada município em cada manancial.',
    };
  },

  computed: {
    ...mapGetters(['bovinesTotalSia']),

    bovinesTotal() {
      const bovines = this.$store.getters.indicator.find(
        (el) => el.indicador == 'pecuaria',
      );

      return {
        totalBovinesSia: this.bovinesTotalSia
          ? this.bovinesTotalSia.TOTAL_Bov
          : null,
        totalBovines: bovines.vals.Bovinos,
        updateDate: bovines.params.data_dado,
        manancial: this.bovinesTotalSia
          ? this.bovinesTotalSia.TOTAL_Bov_km2
          : null,
      };
    },
  },

  methods: {
    toggleBovines() {
      this.bovines = !this.bovines;
    },
  },
};
</script>

<style scoped>
.textDate {
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
}

.textTitle {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0em;
}

.textBovines {
  font-family: 'Roboto';
  font-style: Regular;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
}

.textTotalBovines {
  font-family: 'Roboto';
  font-style: Bold;
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  color: #ffffff;
}

/* width */
::-webkit-scrollbar {
  width: 7px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: darkgrey;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: grey;
}
</style>
